<odx-card [variant]="'launch-tile-centered'" (click)="onSelect()" [ngClass]="{ selected: isSelected }">
  {{ scope.title }}
  <odx-avatar>
    <img [src]="scope.image" [alt]="scope.title" />
  </odx-avatar>
  <odx-launch-card-subtitle>{{ scope.subtitle }}</odx-launch-card-subtitle>
</odx-card>
